import {
    getOrganisation,
    getOrganisationFetchError,
    getOrganisationIsFetching,
} from '@selectors/organisation';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { useEffect } from 'react';
import { fetchOrganisation } from '@actions/assessments';

const useFetchOrganisation = (id: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchOrganisation(id));
    }, [dispatch, id]);

    const organisation = useSelector((state: RootState) => getOrganisation(state, id ?? -1));
    const isFetching = useSelector(getOrganisationIsFetching);
    const fetchError = useSelector(getOrganisationFetchError);

    return { organisation, isFetching, fetchError };
};

export default useFetchOrganisation;
